module.exports = "/fonts/segoe-ui.ttf";